import { RootState } from "../../../../store";

export const appliedFilterTemplateIdSelector = (
  state: RootState,
): string | null => state.filters.appliedFilterSetId;
